import React, { FC } from 'react';
import { GoBackBtn } from '../header/GoBackBtn';
import clsx from 'clsx';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useIdentity } from '../../store/identyti/identity-context';
import { USER_TABS } from '../../constants/users/userModalUtils';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../../routing/routesEnums';

const navigationLinks = [
	{
		path: USER_TABS.USER_INFO,
		text: 'USER.USER_INFO',
		additionalClass: 'd-flex',
	},
	{
		path: USER_TABS.ACCOUNT_SECURITY,
		text: 'USER.USER_SECURITY',
		additionalClass: 'd-flex',
	},
	{
		path: USER_TABS.ACCOUNT,
		text: 'USER.ACCOUNT',
		additionalClass: 'd-flex',
	},
];

export const UserDetailsLayout: FC = () => {
	const { t } = useTranslation();
	const { userId } = useParams();
	const { pathname, search, state } = useLocation();
	const segments = pathname.split('/');
	const activeSection = segments[segments.length - 1];

	const { identityState: { usersList }} = useIdentity();

	const userData = usersList[0];

	return (
		<>
			<div className="mb-5">
				<GoBackBtn path={`${ROUTES.USERS}${state?.search ?? ''}`}/>
			</div>

			<div className="card mb-10">
				<div className="card-body border-bottom d-flex justify-content-between align-items-center">
					<div className="d-flex justify-content-between align-items-center">
						<div
							className="d-flex align-items-center justify-content-center text-danger fw-bolder bg-light-danger rounded-2 profile-icon py-10 px-13">
							<span>{userData?.firstName?.[0].toUpperCase() || ''}</span>
							<span>{userData?.lastName?.[0].toUpperCase() || ''}</span>
						</div>
						<div className="fs-2 fw-bolder ms-13">
							<span>{userData?.firstName || ''}{' '}</span>
							<span>{userData?.lastName || ''}</span>
							<div className="fs-7 text-muted">{userData?.group.join(', ')}</div>
						</div>
					</div>
				</div>
				<div className="d-flex align-items-center merchant-navigation px-9">
					{
						navigationLinks.map(({ path, text, additionalClass }) => (
							<Link
								key={path}
								to={`/users/${userId}/${path}${search}`}
								state={{ ...state }}
								className={clsx(
									'align-items-center justify-content-center fs-8 fs-sm-7 fw-bolder text-center px-3 h-70px tab-style',
									additionalClass,
									activeSection === path ? 'text-danger tab-bgc' : 'text-dark')
								}
							>
								{t(text)}
							</Link>
						))
					}

				</div>
			</div>
		</>
	);
};